import Echo from 'laravel-echo';
/* eslint-disable */
import Pusher from 'pusher-js';
/* eslint-enable */

export default (app) => {
    const echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,

        // For local development with Soketi, we need to specify the host
        ...(import.meta.env.VITE_ENV === 'local' ?
            { wsHost: import.meta.env.VITE_PUSHER_HOST, cluster: import.meta.env.VITE_PUSHER_CLUSTER || 'mt1' }
        :   { cluster: import.meta.env.VITE_PUSHER_CLUSTER }),
        wsPort: import.meta.env.VITE_PUSHER_PORT,
        wssPort: import.meta.env.VITE_PUSHER_PORT,
        forceTLS: import.meta.env.VITE_PUSHER_SCHEME === 'https',
        encrypted: import.meta.env.VITE_PUSHER_SCHEME === 'https',
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        authorizer: (channel) => {
            return {
                authorize: (socketId, callback) => {
                    let token = localStorage.getItem('bearer');
                    let tenantSlug = localStorage.getItem('tenantSlug');
                    let config = {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'X-Tenant': `${tenantSlug}`,
                        },
                    };

                    window.tenantAxios
                        .post(
                            '/broadcasting/auth',
                            {
                                socket_id: socketId,
                                channel_name: channel.name,
                            },
                            {
                                config,
                            },
                        )
                        .then((response) => {
                            console.debug(
                                `(tenant ${tenantSlug}) ws success auth response for ${socketId} ${channel.name}`,
                                response.data,
                            );

                            callback(false, response.data);
                        })
                        .catch((error) => {
                            console.debug(
                                `(tenant ${tenantSlug}) ws error auth response ${socketId} ${channel.name}`,
                                error,
                            );

                            callback(true, error);
                        });
                },
            };
        },
    });

    app.config.globalProperties.$echo = echo;
    window.echo = echo;
};
